import styled, { css } from 'styled-components';
import { StatBlock, StatBlockComponentProps } from '@bechtel/client-dashboard-common';
import { Box } from '@bechtel/gds';

export const DashboardContainerStyled = styled.div`
  overflow-y: auto;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const DashboardPersonaContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const StatBlockStyled = styled(StatBlock)`
  ${(props: StatBlockComponentProps) =>
    parseInt(props.value) === 0
      ? css`
          pointer-events: none;
        `
      : css`
          cursor: pointer;
        `}
`;
